(function () {
  function initDeliveryPopup() {
    const popup = document.getElementById("deliveryPopup");
    if (!popup) {
      console.log("Delivery popup HTML not found");
      return;
    }

    const closeBtn = document.getElementById("deliveryPopupClose");
    const stepOne = document.getElementById("deliveryStepOne");
    const stepTwo = document.getElementById("deliveryStepTwo");
    const postcodeInput = document.getElementById("deliveryPostcodeInput");
    const checkBtn = document.getElementById("deliveryCheckBtn");
    const errorBox = document.getElementById("deliveryError");
    const selectedPostcodeText = document.getElementById("selectedPostcodeText");
    const editPostcodeBtn = document.getElementById("editPostcodeBtn");
    const startBtn = document.getElementById("deliveryStartBtn");
    const addressSelect = document.getElementById("deliveryAddressSelect");
    const addressError = document.getElementById("addressError");
    const emailInput = document.getElementById("deliveryEmailInput");
    const zoneMessage = document.getElementById("deliveryZoneMessage");
    const briefResult = document.getElementById("deliveryBriefResult");

    // NEW: detailed per-zone result boxes (added alongside the existing zoneMessage box)
    const resultBoxLocal = document.querySelector(".delivery-result-local");
    const resultBoxCourier = document.querySelector(".delivery-result-courier");
    const resultBoxUnavailable = document.querySelector(".delivery-result-unavailable");

    const deliveryAddressTopbar = document.getElementById("deliveryAddressTopbar");
    const deliveryAddressTopbarText = document.getElementById("deliveryAddressTopbarText");
    const deliveryAddressTopbarEdit = document.getElementById("deliveryAddressTopbarEdit");

    let pendingForm = null;
    let pendingCategoryUrl = null;
    let currentPostcodeAllowed = true;
    let currentDeliveryResult = null;

    // Whole outward codes that qualify for Sarthi Mart Local Delivery.
    const localPostcodes = [
      "HA0", "HA1", "HA2", "HA3", "HA4", "HA5", "HA7", "HA8", "HA9",
      "NW4", "NW7", "NW9", "UB5", "UB6"
    ];

    // No sector-only local delivery exceptions are currently configured.
    const localPostcodeSectors = [];
    const scotlandAllowed = [
      "AB10", "AB11", "AB12", "AB13", "AB14", "AB15", "AB16",
      "AB21", "AB22", "AB23", "AB24", "AB25",
      "AB30", "AB31", "AB32", "AB33", "AB34", "AB35", "AB36", "AB39",

      "DD1", "DD2", "DD3", "DD4", "DD5", "DD6", "DD7", "DD8", "DD9", "DD10", "DD11",

      "EH1", "EH2", "EH3", "EH4", "EH5", "EH6", "EH7", "EH8", "EH9",
      "EH10", "EH11", "EH12", "EH13", "EH14", "EH15", "EH16", "EH17", "EH18", "EH19",
      "EH20", "EH21", "EH22", "EH23", "EH24", "EH25", "EH26", "EH27", "EH28", "EH29",
      "EH30", "EH31", "EH32", "EH33", "EH34", "EH35", "EH36", "EH37", "EH38", "EH39",
      "EH40", "EH41", "EH42", "EH43", "EH44", "EH45", "EH46", "EH47", "EH48", "EH49",
      "EH50", "EH51", "EH52", "EH53", "EH54", "EH55",

      "FK1", "FK2", "FK3", "FK4", "FK5", "FK6", "FK7", "FK8",
      "FK9", "FK10", "FK11", "FK12", "FK13", "FK14", "FK15", "FK16",

      "PH1", "PH2", "PH3", "PH4", "PH5", "PH6", "PH7", "PH8",
      "PH9", "PH10", "PH11", "PH12", "PH13", "PH14",

      "G1", "G2", "G3", "G4", "G5", "G6", "G7", "G8", "G9",
      "G10", "G11", "G12", "G13", "G14", "G15",
      "G20", "G21", "G22", "G23",
      "G31", "G32", "G33", "G34",
      "G40", "G41", "G42", "G43", "G44", "G45", "G46",
      "G50", "G51", "G52", "G53",
      "G57", "G58", "G59", "G60", "G61", "G62", "G63", "G64", "G65", "G66", "G67",
      "G68", "G69", "G70", "G71", "G72", "G73", "G74", "G75", "G76", "G77", "G78",
      "G79", "G80", "G81", "G82", "G83", "G84",

      "KA1", "KA2", "KA3", "KA4", "KA5", "KA6", "KA7", "KA8", "KA9",
      "KA10", "KA11", "KA12", "KA13", "KA14", "KA15", "KA16", "KA17", "KA18",
      "KA19", "KA20", "KA21", "KA22", "KA23", "KA24", "KA25", "KA26", "KA29", "KA30",

      "KY1", "KY2", "KY3", "KY4", "KY5", "KY6", "KY7", "KY8", "KY9",
      "KY10", "KY11", "KY12", "KY13", "KY14", "KY15", "KY16", "KY99",

      "ML1", "ML2", "ML3", "ML4", "ML5", "ML6", "ML7", "ML8", "ML9", "ML10", "ML11", "ML12",

      "PA1", "PA2", "PA3", "PA4", "PA5", "PA6", "PA7", "PA8", "PA9",
      "PA10", "PA11", "PA12", "PA13", "PA14", "PA15", "PA16", "PA17", "PA18", "PA19"
    ];

    const scotlandAreas = [
      "AB", "DD", "DG", "EH", "FK", "G", "HS", "IV", "KA", "KW", "KY", "ML", "PA", "PH", "TD", "ZE"
    ];

    const blockedAreas = []; // Special areas are handled by dedicated delivery zones below.

    const blockedOutwardPostcodes = [
      "PO30", "PO31", "PO32", "PO33", "PO34", "PO35",
      "PO36", "PO37", "PO38", "PO39", "PO40", "PO41"
    ];

    function isScottishHighlandsOutward(outward) {
      if (!outward) return false;
      if (/^(HS|IV|KW|ZE)/.test(outward)) return true;
      if (["AB37","AB38","AB54","AB55","AB56","FK17","FK18","FK19","FK20","FK21","KA27","KA28"].includes(outward)) return true;

      const pa = outward.match(/^PA(\d{1,2})$/);
      if (pa) {
        const n = parseInt(pa[1], 10);
        if ((n >= 20 && n <= 49) || (n >= 60 && n <= 78)) return true;
      }

      const ph = outward.match(/^PH(\d{1,2})$/);
      if (ph) {
        const n = parseInt(ph[1], 10);
        if ((n >= 19 && n <= 26) || (n >= 30 && n <= 40) || (n >= 42 && n <= 44) || n === 49 || n === 50) return true;
      }

      return false;
    }



    function openPopup() {
      popup.classList.add("active");
      document.body.style.overflow = "hidden";

      setTimeout(function () {
        if (postcodeInput) postcodeInput.focus();
      }, 100);
    }

    function closePopup() {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }

    function cleanPostcode(postcode) {
      return String(postcode || "").toUpperCase().replace(/\s+/g, "");
    }

    function getOutwardCode(postcode) {
      const clean = cleanPostcode(postcode);

      // Allows customer to enter only first part, like HA7, EH12, G61
      if (/^[A-Z]{1,2}\d[A-Z\d]?$/.test(clean)) {
        return clean;
      }

      // Allows full postcode, like HA7 1AB, EH12 5AB, G61 2AA
      if (/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(clean)) {
        return clean.slice(0, -3);
      }

      return "";
    }

    // NEW: extract "<outward code> <sector digit>" (e.g. "UB10 8") - only
    // possible when the FULL postcode is entered, since the sector digit
    // is the first character of the inward code.
    function getSectorCode(postcode) {
      const clean = cleanPostcode(postcode);

      if (/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(clean)) {
        const outward = clean.slice(0, -3);
        const sectorDigit = clean.slice(-3, -2);
        return outward + " " + sectorDigit;
      }

      return "";
    }

    function getPostcodeArea(outwardCode) {
      const match = String(outwardCode || "").match(/^[A-Z]+/);
      return match ? match[0] : "";
    }

    function formatPostcode(postcode) {
      const clean = cleanPostcode(postcode);

      // If only outward code entered, keep it same
      if (/^[A-Z]{1,2}\d[A-Z\d]?$/.test(clean)) {
        return clean;
      }

      // If full postcode entered, format with space
      if (/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(clean)) {
        return clean.slice(0, -3) + " " + clean.slice(-3);
      }

      return clean;
    }

    function checkDelivery(postcode) {
      const clean = cleanPostcode(postcode);
      const outward = getOutwardCode(clean);
      const sector = getSectorCode(clean);
      const area = getPostcodeArea(outward);

      if (!outward || !area) {
        return {
          zone: "INVALID",
          shopifyZone: "invalid",
          allowed: false,
          message: "Please enter a valid UK postcode."
        };
      }

      if (localPostcodes.includes(outward) || localPostcodeSectors.includes(sector)) {
        return {
          zone: "ZONE_1",
          shopifyZone: "zone_1_local",
          allowed: true,
          outward: outward,
          message: "Sarthi Mart Local Delivery Available.",
          briefHtml: "<strong>✓ Local Delivery Available</strong><br>FREE on £25+ orders • Same-day Wed–Mon when ordered before 3 PM"
        };
      }

      // Isle of Wight remains unchanged while courier pricing is under review.
      if (blockedOutwardPostcodes.includes(outward)) {
        return {
          zone: "NOT_DELIVERING",
          shopifyZone: "blocked",
          allowed: false,
          outward: outward,
          message: "Sorry, Isle of Wight delivery is not currently available through our postcode checker."
        };
      }

      if (area === "BT") {
        return {
          zone: "ZONE_NI",
          shopifyZone: "zone_northern_ireland",
          allowed: true,
          outward: outward,
          message: "Northern Ireland Delivery Available.",
          briefHtml: "<strong>✓ Northern Ireland Delivery Available</strong><br>Parcelforce / Royal Mail • from £12.79 up to 22 kg • estimated 2–5 days"
        };
      }

      if (area === "JE") {
        return {
          zone: "ZONE_JERSEY",
          shopifyZone: "zone_jersey",
          allowed: true,
          outward: outward,
          message: "Jersey Delivery Available.",
          briefHtml: "<strong>✓ Jersey Delivery Available</strong><br>Parcelforce / Royal Mail • from £10 up to 17.5 kg • estimated 2–5 days"
        };
      }

      if (area === "GY") {
        return {
          zone: "ZONE_GUERNSEY",
          shopifyZone: "zone_guernsey",
          allowed: true,
          outward: outward,
          message: "Guernsey Delivery Available.",
          briefHtml: "<strong>✓ Guernsey Delivery Available</strong><br>DPD • from £22 up to 27 kg • estimated 2–8 days"
        };
      }

      if (area === "IM") {
        return {
          zone: "ZONE_IOM",
          shopifyZone: "zone_isle_of_man",
          allowed: true,
          outward: outward,
          message: "Isle of Man Delivery Available.",
          briefHtml: "<strong>✓ Isle of Man Delivery Available</strong><br>Parcelforce / Royal Mail • from £12.79 up to 22 kg • estimated 2–5 days"
        };
      }

      if (isScottishHighlandsOutward(outward)) {
        return {
          zone: "ZONE_HIGHLANDS",
          shopifyZone: "zone_highlands",
          allowed: true,
          outward: outward,
          message: "Scottish Highlands & Islands Delivery Available.",
          briefHtml: "<strong>✓ Scottish Highlands & Islands Delivery Available</strong><br>DPD • from £13.80 up to 27.5 kg • estimated 2–4 days"
        };
      }

      return {
        zone: "ZONE_2",
        shopifyZone: "zone_2_uk",
        allowed: true,
        outward: outward,
        message: "DPD UK Mainland Delivery Available.",
        briefHtml: "<strong>✓ UK Mainland Delivery Available</strong><br>FREE over £75 up to 28 kg • aim next working day • standard 2–4 working days"
      };
    }

    // NEW: maps a checkDelivery() result to which detailed result box should show
    function getResultBoxKey(result) {
      if (!result.allowed) return "unavailable";
      if (result.zone === "ZONE_1") return "local";
      return "courier";
    }

    // NEW: shows only the matching detailed result box, hides the other two
    function updateResultBoxes(result) {
      const key = result ? getResultBoxKey(result) : null;

      if (resultBoxLocal) resultBoxLocal.classList.toggle("active", key === "local");
      if (resultBoxCourier) resultBoxCourier.classList.toggle("active", key === "courier");
      if (resultBoxUnavailable) resultBoxUnavailable.classList.toggle("active", key === "unavailable");
    }

    function updateDeliveryAddressTopbar() {
      const checked = localStorage.getItem("delivery_checked") === "yes";
      const postcode = localStorage.getItem("delivery_postcode") || "";
      const zone = localStorage.getItem("delivery_zone") || "";

      if (!deliveryAddressTopbar || !deliveryAddressTopbarText) return;

      if (!checked || !postcode || zone === "blocked" || zone === "invalid") {
        deliveryAddressTopbarText.textContent = "";
        deliveryAddressTopbar.style.setProperty("display", "none", "important");
        return;
      }

      // Keep the postcode system active, but hide the green postcode status bar
      // once a valid postcode has been saved.
      deliveryAddressTopbarText.textContent = "";
      deliveryAddressTopbar.style.setProperty("display", "none", "important");
      return;
    }

    function clearDeliveryData() {
      localStorage.removeItem("delivery_checked");
      localStorage.removeItem("delivery_postcode");
      localStorage.removeItem("delivery_zone");
      localStorage.removeItem("delivery_email");
      localStorage.removeItem("delivery_checked_at"); // NEW: clear expiry timestamp too

      if (deliveryAddressTopbarText) {
        deliveryAddressTopbarText.textContent = "";
      }

      if (deliveryAddressTopbar) {
        deliveryAddressTopbar.style.setProperty("display", "none", "important");
      }

      if (postcodeInput) {
        postcodeInput.value = "";
      }

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          attributes: {
            Delivery_Postcode: "",
            Delivery_Zone: "",
            Delivery_Email: ""
          }
        })
      }).catch(function () {});
    }

    function resetToStepOne() {
      currentPostcodeAllowed = true;
      currentDeliveryResult = null;

      if (stepOne) stepOne.style.display = "block";
      if (stepTwo) stepTwo.style.display = "none";
      if (errorBox) errorBox.style.display = "none";
      if (briefResult) {
        briefResult.style.display = "none";
        briefResult.innerHTML = "";
      }
      if (addressError) addressError.style.display = "none";

      if (zoneMessage) {
        zoneMessage.style.display = "none";
        zoneMessage.className = "delivery-zone-box";
        zoneMessage.innerHTML = "";
      }

      // NEW: clear all detailed result boxes when resetting
      updateResultBoxes(null);

      if (startBtn) {
        startBtn.disabled = false;
        startBtn.classList.remove("is-disabled");
      }

      if (addressSelect && !addressSelect.value) {
        addressSelect.value = "manual";
      }
    }

    async function getCartData() {
      try {
        const res = await fetch("/cart.js");
        return await res.json();
      } catch (e) {
        return {
          total_price: 0,
          total_weight: 0
        };
      }
    }

    async function showStepTwo(postcode) {
      const formattedPostcode = formatPostcode(postcode);
      const result = checkDelivery(formattedPostcode);

      currentDeliveryResult = result;
      currentPostcodeAllowed = result.allowed;

      await getCartData();

      if (selectedPostcodeText) {
        selectedPostcodeText.textContent = formattedPostcode;
      }

      if (zoneMessage) {
        zoneMessage.style.display = "block";

        if (!result.allowed) {
          zoneMessage.className = "delivery-zone-box zone-blocked-message";
          zoneMessage.innerHTML = result.message;
        } else if (result.zone === "ZONE_1") {
          zoneMessage.className = "delivery-zone-box zone-one-message";
          zoneMessage.innerHTML = result.message;
        } else {
          zoneMessage.className = "delivery-zone-box zone-two-message";
          zoneMessage.innerHTML = result.message;
        }
      }

      // NEW: show the matching detailed result box (Local / Courier / Unavailable)
      updateResultBoxes(result);

      if (startBtn) {
        if (!result.allowed) {
          startBtn.disabled = true;
          startBtn.classList.add("is-disabled");
          startBtn.textContent = "Check Another Postcode";
        } else {
          startBtn.disabled = false;
          startBtn.classList.remove("is-disabled");
          startBtn.textContent = "Start Shopping";
        }
      }

      if (addressSelect && !addressSelect.value) {
        addressSelect.value = "manual";
      }

      if (stepOne) stepOne.style.display = "none";
      if (stepTwo) stepTwo.style.display = "block";
    }

    // UPDATED: now also checks a 7-day expiry timestamp, not just the flag.
    // Older saved data without a timestamp is treated as valid once (it will
    // pick up a timestamp on the next saveDeliveryData() call).
    function hasDeliveryChecked() {
      const checked = localStorage.getItem("delivery_checked") === "yes";
      if (!checked) return false;

      const checkedAt = parseInt(localStorage.getItem("delivery_checked_at") || "0", 10);
      if (!checkedAt) return true;

      const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
      const isExpired = (Date.now() - checkedAt) > sevenDaysMs;

      if (isExpired) {
        clearDeliveryData();
        return false;
      }

      return true;
    }

    // Mirrors the isLocal check in the inline <head> script (layout/theme.liquid).
    // Keep in sync if that logic changes.
    function isConfirmedLocal() {
      const checked = localStorage.getItem("delivery_checked") === "yes";
      const zone = localStorage.getItem("delivery_zone");
      const checkedAt = parseInt(localStorage.getItem("delivery_checked_at") || "0", 10);
      const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
      const expired = checkedAt ? (Date.now() - checkedAt) > sevenDaysMs : false;

      return checked && zone === "zone_1_local" && !expired;
    }

    // Applies the zone-not-local class to the current document based on
    // whatever is currently in localStorage. Shared by the same-tab update
    // (called right after saveDeliveryData writes to localStorage) and the
    // cross-tab sync below (storage event never fires in the tab that made
    // the change, only in other open tabs/windows).
    function applyZoneClass() {
      if (isConfirmedLocal()) {
        document.documentElement.classList.remove("zone-not-local");
      } else {
        document.documentElement.classList.add("zone-not-local");
      }
    }

    // NEW: keeps the zone-not-local class (and therefore restricted-content
    // visibility) in sync across tabs. The "storage" event only fires in
    // OTHER tabs/windows when localStorage changes - not the tab that made
    // the change - so a visitor who confirms their postcode in one tab will
    // see restricted content unlock in any other open tab without a reload.
    function syncZoneClassFromStorage(event) {
      if (event && event.key && ["delivery_checked", "delivery_zone", "delivery_checked_at"].indexOf(event.key) === -1) {
        return;
      }

      applyZoneClass();
      updateDeliveryAddressTopbar();
    }

    function saveDeliveryData() {
      const formattedPostcode = formatPostcode(postcodeInput.value.trim());
      const result = currentDeliveryResult || checkDelivery(formattedPostcode);
      const zone = result.shopifyZone || "zone_2_uk";

      localStorage.setItem("delivery_checked", "yes");
      localStorage.setItem("delivery_postcode", formattedPostcode);
      localStorage.setItem("delivery_zone", zone);
      localStorage.setItem("delivery_checked_at", String(Date.now())); // NEW: timestamp for 7-day expiry

      if (emailInput && emailInput.value.trim()) {
        localStorage.setItem("delivery_email", emailInput.value.trim());
      }

      // Update this tab's own zone class immediately - the "storage" event
      // used for cross-tab sync never fires in the tab that made the change.
      applyZoneClass();
      updateDeliveryAddressTopbar();

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          attributes: {
            Delivery_Postcode: formattedPostcode,
            Delivery_Zone: zone,
            Delivery_Email: emailInput ? emailInput.value.trim() : ""
          }
        })
      }).catch(function () {});
    }

    async function addToCartAjax(form) {
      const formData = new FormData(form);

      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        form.submit();
        return;
      }

      // Match the same sections/cartUpdate flow theme-global.js's product-form
      // uses, so the cart-count bubble and drawer content actually refresh.
      // The old version only dispatched "cart:refresh" + three dead custom
      // events nothing listens for ("cart:open", "minimog:cart:refresh",
      // "minimog:cart:open"), which left the header cart count stuck at its
      // pre-add value until a full page reload.
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      formData.append("sections", sectionsToBundle);
      formData.append("sections_url", window.location.pathname);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json"
          }
        });

        if (!response.ok) {
          throw new Error("Add to cart failed");
        }

        const cart = await response.json();

        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: cart });
        }

        if (window.SarthiCartToast && window.MinimogStrings) {
          window.SarthiCartToast.show(window.MinimogStrings.itemAdded);
        }

        document.dispatchEvent(
          new CustomEvent("product-ajax:added", { detail: { product: cart } })
        );
      } catch (error) {
        form.submit();
      }
    }

    function handleAddToCartClick(e) {
      const clickedButton = e.target.closest(
        'button[name="add"], button[type="submit"], .m-add-to-cart, .product-form__submit, .sf__btn-addtocart, .add-to-cart, [data-add-to-cart], [name="add"]'
      );

      if (!clickedButton) return;

      const form = clickedButton.closest("form");
      if (!form) return;

      const action = form.getAttribute("action") || "";
      if (!action.includes("/cart/add")) return;

      if (!hasDeliveryChecked()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        pendingForm = form;
        resetToStepOne();
        openPopup();
      }
    }

    function handleAddToCartSubmit(e) {
      const form = e.target;
      if (!form || !form.matches("form")) return;

      const action = form.getAttribute("action") || "";
      if (!action.includes("/cart/add")) return;

      if (!hasDeliveryChecked()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        pendingForm = form;
        resetToStepOne();
        openPopup();
      }
    }

    // If a visitor closed the first popup without saving a postcode, ask again
    // when they try to open any collection/category. After a successful save,
    // continue automatically to the category they originally clicked.
    function handleCategoryLinkClick(e) {
      const target = e.target;
      if (!target || !target.closest) return;

      const link = target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute("href") || "";
      const isCollectionLink = href === "/collections" || href.indexOf("/collections/") !== -1;
      if (!isCollectionLink || hasDeliveryChecked()) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      pendingCategoryUrl = link.href || href;
      resetToStepOne();
      openPopup();
    }

    if (checkBtn) {
      checkBtn.addEventListener("click", function () {
        const postcode = postcodeInput.value.trim();
        const result = checkDelivery(postcode);

        if (result.zone === "INVALID" || !result.allowed) {
          if (errorBox) {
            errorBox.textContent = result.message;
            errorBox.style.display = "block";
          }
          return;
        }

        if (errorBox) errorBox.style.display = "none";

        currentDeliveryResult = result;
        currentPostcodeAllowed = true;
        saveDeliveryData();

        const categoryUrl = pendingCategoryUrl;
        const formToAdd = pendingForm;
        pendingCategoryUrl = null;
        pendingForm = null;

        if (stepOne) stepOne.style.display = "none";

        if (briefResult) {
          if (result.zone === "ZONE_1") {
            briefResult.className = "delivery-zone-box zone-one-message";
          } else {
            briefResult.className = "delivery-zone-box zone-two-message";
          }
          briefResult.innerHTML = result.briefHtml || result.message;
          briefResult.style.display = "block";
        }

        setTimeout(function () {
          closePopup();
          resetToStepOne();

          if (formToAdd) {
            addToCartAjax(formToAdd);
          } else if (categoryUrl) {
            var isVegetablesUrl = categoryUrl.indexOf("/collections/vegetables") !== -1;
            if (isVegetablesUrl && result.shopifyZone !== "zone_1_local") {
              var vegModal = document.getElementById("sarthiVegLocalModal");
              if (vegModal) {
                vegModal.classList.add("is-open");
                vegModal.setAttribute("aria-hidden", "false");
                document.body.style.overflow = "hidden";
              }
            } else {
              window.location.href = categoryUrl;
            }
          }
        }, 2300);
      });
    }

    if (postcodeInput) {
      postcodeInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          if (checkBtn) checkBtn.click();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });

    document.addEventListener("click", handleCategoryLinkClick, true);
    document.addEventListener("click", handleAddToCartClick, true);
    document.addEventListener("submit", handleAddToCartSubmit, true);
    window.addEventListener("storage", syncZoneClassFromStorage);

    if (deliveryAddressTopbarEdit) {
      deliveryAddressTopbarEdit.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        clearDeliveryData();
        resetToStepOne();
        updateDeliveryAddressTopbar();
        openPopup();

        setTimeout(function () {
          if (postcodeInput) postcodeInput.focus();
        }, 150);
      });
    }

    // Draft preview helper: on the first load of this draft in a browser tab,
    // clear postcode data inherited from the live theme so the popup can be tested.
    // Once a postcode is saved, it remains saved while browsing this draft.
    try {
      const previewId = new URLSearchParams(window.location.search).get("preview_theme_id");
      const previewResetKey = "sarthi_preview_postcode_reset_208087581010";
      if (previewId === "208087581010" && !sessionStorage.getItem(previewResetKey)) {
        localStorage.removeItem("delivery_checked");
        localStorage.removeItem("delivery_postcode");
        localStorage.removeItem("delivery_zone");
        localStorage.removeItem("delivery_email");
        localStorage.removeItem("delivery_checked_at");
        sessionStorage.setItem(previewResetKey, "yes");
      }
    } catch (e) {}

    updateDeliveryAddressTopbar();

    // Ask new/unconfirmed visitors for their postcode as soon as they land,
    // so restricted categories (Veggies & Frozen) come with an obvious next
    // step instead of just disappearing silently.
    if (!hasDeliveryChecked()) {
      setTimeout(function () {
        resetToStepOne();
        openPopup();
      }, 600);
    }

    window.openDeliveryPopup = openPopup;

    console.log("Delivery popup loaded successfully");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDeliveryPopup);
  } else {
    initDeliveryPopup();
  }
})();